import { render, staticRenderFns } from "./CertificateQuery.vue?vue&type=template&id=12dec4ec&scoped=true"
import script from "./CertificateQuery.vue?vue&type=script&lang=js"
export * from "./CertificateQuery.vue?vue&type=script&lang=js"
import style0 from "./CertificateQuery.vue?vue&type=style&index=0&id=12dec4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dec4ec",
  null
  
)

export default component.exports